import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHighcharts from '../CommonComponents/Highcharts';
import LoadingChart from '../CommonComponents/LoadingChart';
import { createCustomPropType, isUuid, isNumeric } from '../../js/app/react/validators';
import { Text } from '../CommonComponents/OPL/Text/Text';

class EducationChartView extends Component {
  componentDidMount() {
    const { hasChartData, dataIsOutdated, isPrint } = this.props;

    if ((!hasChartData || dataIsOutdated) && !isPrint) {
      const { clientId, fpId, getChartData, goalId, isPdf } = this.props;
      getChartData(fpId, clientId, isPdf, goalId);
    }
  }

  render() {
    const { isPrint, chartData, hasLoaded, showLabel, showTitle, chartTitle } = this.props;

    return (
      <section
        className="
                education-chart-component
                chart"
      >
        <div
          className="
                    NewFinancialPlan_ProgressChart
                    NewFinancialPlan_EducationProgressChart"
        >
          {showTitle && (
            <Text as="h2" fontSize="h6" color="primary.500">
              {chartTitle}
            </Text>
          )}
          <div
            className="
                        chart
                        NewFinancialPlan_EducationProgressChart_BarChart"
          >
            {showLabel && (
              <ul className="legend">
                <li>
                  <i className="blue" />
                  Expenses Covered
                </li>
                <li>
                  <i className={`stripe2 ${isPrint ? 'isPrint' : ''}`} />
                  Expenses Not Covered
                </li>
              </ul>
            )}
            {!hasLoaded && <LoadingChart />}
            {hasLoaded && (
              <ReactHighcharts
                autoResize
                className="education-chart-container"
                container="EducationChartContainer"
                options={chartData}
              />
            )}
          </div>
        </div>
      </section>
    );
  }
}

EducationChartView.defaultProps = {
  chartTitle: '',
  isPdf: false,
  isPrint: false,
  showLabel: true,
  showTitle: true,
};

EducationChartView.propTypes = {
  chartData: PropTypes.shape({}).isRequired,
  chartTitle: PropTypes.string,
  clientId: createCustomPropType(isNumeric).isRequired,
  dataIsOutdated: PropTypes.bool.isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  getChartData: PropTypes.func.isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  hasChartData: PropTypes.bool.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  isPdf: PropTypes.bool,
  isPrint: PropTypes.bool,
  showLabel: PropTypes.bool,
  showTitle: PropTypes.bool,
};

export default EducationChartView;
